import { z } from 'zod';

export const WhatViewport = z.object({
  xs: z.boolean(),
  sm: z.boolean(),
  md: z.boolean(),
  lg: z.boolean(),
  xl: z.boolean(),
  xxl: z.boolean(),
  smUp: z.boolean(),
  mdUp: z.boolean(),
  lgUp: z.boolean(),
  xlUp: z.boolean(),
  smDown: z.boolean(),
  mdDown: z.boolean(),
  lgDown: z.boolean(),
  xlDown: z.boolean(),
  mobile: z.boolean(),
  midsize: z.boolean(),
  desktop: z.boolean(),
});

export type WhatViewport = z.infer<typeof WhatViewport>;
